






































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import ModalDelete from '@/app/ui/components/ModalDelete/index'
import ModalImage from '@/app/ui/components/ImageGallery/index.vue'
import ImageSelect from '@/app/ui/components/SelectImage/index.vue'
import { AdditionalModule } from '@/app/store/modules/additionalinfo'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { defaultImage } from '@/utils/default'

@Component({
  components: {
    'modal-delete': ModalDelete,
    'modal-image': ModalImage,
    'image-select': ImageSelect,
    'date-picker': DatePicker,
  },
})
export default class extends Vue {
  @Prop({}) public onPageLimit
  @Prop({}) public onPageNumChanged
  @Prop({}) public dataTable
  @Prop({}) public isLoading
  @Prop({}) public fields: any[] | undefined
  @Prop({}) public selected: any[] | undefined
  @Prop({}) public imageDataCategory
  @Prop({}) public clearTableStatus
  public disableDate(date) {
    return date < new Date()
  }
  public get isFilledDataTable() {
    return (
      this.dataTable !== undefined && this.dataTable.pagination !== undefined
    )
  }

  @Watch('clearTableStatus')
  public onPropertyChanged(value: boolean, oldValue: boolean) {
    this.$refs.selectableTable.clearSelected()
  }
  // Form Edit
  public freeText: string = ''
  public month: string = ''
  public year: string = ''
  public id: number = 0
  public title: string = ''
  public dateTimeexpired: string = ''
  public get loading() {
    return this.isLoading
  }
  public get stateExpiredDate() {
    return this.dateTimeexpired !== null ? true : false
  }
  public get stateTitle() {
    return this.title.length > 4 ? true : false
  }
  public get stateFreeText() {
    return this.freeText.length >= 2 ? true : false
  }
  public get stateMonth() {
    return true
  }
  public get stateYear() {
    return true
  }
  public imageThumbnailId: any = {
    id: null,
    link: defaultImage,
  }

  // Property Select Status
  public isActive: boolean = true
  public isDownloadable: boolean = true
  public optionsIsActive: any = [
    {
      text: 'Active',
      value: true,
    },
    {
      text: 'Inactive',
      value: false,
    },
  ]

  // Property Select Recomended
  public isRecommended: boolean = true
  public optionsIsRecommended: any = [
    {
      text: 'Yes',
      value: true,
    },
    {
      text: 'No',
      value: false,
    },
  ]
  // Property Base64
  public hasFiles = {
    fileName: '',
    fileByte: '',
    fileUpload: null,
  }
  public base64Pdf(event) {
    const input = event.target
    if (input.files && input.files[0]) {
      const reader = new FileReader()
      reader.onload = (e: any) => {
        const hash = e.target.result.split(',')
        this.hasFiles = {
          fileName: input.files[0].name,
          fileByte: hash.length ? hash[1] : '',
          fileUpload: input.files[0],
        }
      }
      reader.readAsDataURL(input.files[0])
    }
  }

  // Function Edit
  public funcEdit(item, index, button) {
    // console.log('item', item.expireddate)
    // console.log(item)
    this.freeText = item.file.code.split('-')[0]
    this.month = item.file.code.split('-')[1]
    this.year = item.file.code.split('-')[2]
    this.id = item.id
    this.title = item.title
    this.isActive = item.isActive
    this.isDownloadable = item.isDownloadable
    this.isRecommended = item.isRecommended
    this.file = item.file
    this.imageThumbnailId.id = item.imageThumbnail.image_id
    this.imageThumbnailId.link = item.imageThumbnail.link
    this.dateTimeexpired = item.expireddate
    this.$root.$emit('bv::show::modal', 'modal-edit', button)
  }
  public file: Object = {}

  public patchData(item, index, button) {
    if (
      this.stateTitle === false ||
      this.stateFreeText === false ||
      this.stateMonth === false ||
      this.dateTimeexpired === null ||
      this.stateYear === false
    ) {
      return
    } else {
      const dataToEdit = {
        id: this.id,
        title: this.title,
        fileCode: this.freeText + '-' + this.month + '-' + this.year,
        imageThumbnailId: this.imageThumbnailId.id,
        isActive: this.isActive,
        isDownloadable: this.isDownloadable,
        isRecommended: this.isRecommended,
        fileName: this.hasFiles.fileName,
        fileByte: this.hasFiles.fileByte,
        fileUpload: this.hasFiles.fileUpload,
        expireddate: this.dateTimeexpired,
      }
      AdditionalModule.updateAdditional(dataToEdit)
      this.$root.$emit('bv::hide::modal', 'modal-edit', button)
    }
  }

  public modalDelete = {
    id: 'modal-delete',
    idBulletin: 0,
    title: '',
  }
  public optionsStatus = [
    {
      text: 'Active',
    },
    {
      text: 'Inactive',
    },
  ]
  public optionsRecomended = [
    {
      value: 'true',
      text: 'Yes',
    },
    {
      value: 'false',
      text: 'No',
    },
  ]
  public $refs!: {
    selectableTable: HTMLFormElement
  }
  public postBulletin: any = {
    id: 'modal-edit',
    title: '',
    status: 'Active',
    recomended: true,
    file: null,
    imageThumbnail: null,
    imageUrl: '',
  }
  public imageData = ''
  public onRowSelected(items) {
    this.$emit('onRowSelected', items)
  }
  public selectAllRows() {
    if (this.$props.selected.length === this.dataTable.data.length) {
      this.$refs.selectableTable.clearSelected()
    } else {
      this.$refs.selectableTable.selectAllRows()
    }
  }
  public previewImage(event) {
    const input = event.target
    if (input.files && input.files[0]) {
      const reader = new FileReader()
      reader.onload = (e: any) => {
        this.imageData = e.target.result
      }
      reader.readAsDataURL(input.files[0])
    }
  }

  public onPaste(evt) {
    return evt.preventDefault()
  }

  // validate input sales-code
  public freeTextPress(evt) {
    evt = evt ? evt : window.event
    const charCode = evt.which ? evt.which : evt.keyCode
    if (this.freeText.length > 4) {
      evt.preventDefault()
    } else {
      return true
    }
  }
  public monthPress(evt) {
    evt = evt ? evt : window.event
    const charCode = evt.which ? evt.which : evt.keyCode
    if (
      this.month.length > 1 ||
      (charCode > 31 && (charCode < 48 || charCode > 57))
    ) {
      evt.preventDefault()
    } else {
      return true
    }
  }
  public yearPress(evt) {
    evt = evt ? evt : window.event
    const charCode = evt.which ? evt.which : evt.keyCode
    if (
      this.year.length > 3 ||
      (charCode > 31 && (charCode < 48 || charCode > 57))
    ) {
      evt.preventDefault()
    } else {
      return true
    }
  }

  public funcDelete(item, index, button) {
    if (this.$props.selected.length < 1) {
      this.modalDelete.idBulletin = item.id
      this.modalDelete.title = item.title
      this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
    }
  }
  public deleteNotif() {
    const ids = [this.modalDelete.idBulletin]
    AdditionalModule.deleteAdditional({
      ids,
    })
    this.$root.$emit('bv::hide::modal', 'modal-delete')
  }

  public resetEditModal() {
    this.postBulletin.title = ''
    this.postBulletin.status = 'Active'
    this.postBulletin.download = true
    this.postBulletin.recomended = true
    this.postBulletin.file = null
    this.postBulletin.imageThumbnail = null
    this.postBulletin.imageUrl = ''
    this.imageData = ''
    this.dateTimeexpired = ''
  }
  public resetDeleteModal() {
    this.modalDelete.idBulletin = 0
    this.modalDelete.title = ''
  }
  public get buttonDisable(): boolean {
    if (this.$props.selected.length < 1) {
      return false
    } else {
      return true
    }
  }
  public changeImageThumbnailId(item) {
    this.imageThumbnailId.id = item.id
    this.imageThumbnailId.link = item.link
  }
  public cancelImageThumbnailId() {
    this.imageThumbnailId.id = null
    this.imageThumbnailId.link = defaultImage
  }
}
